import { Download } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { SingleMessageType } from "DataTypes/Chat.type";
import { FC } from "react";

export interface AttachmentCompType {
  message: SingleMessageType;
  setSelectedDocument: ({
    attachmentUrl,
    docType,
  }: {
    attachmentUrl: string;
    docType: "image" | "video";
  }) => void;
  downloadImage: (attachmentUrl: string, fileName: string) => void;
}

const AttachmentComponent: FC<AttachmentCompType> = (
  props: AttachmentCompType
) => {
  const { message, setSelectedDocument, downloadImage } = props;
  return (
    <Box>
      {message.fileName?.match(/\.(jpg|jpeg|png|gif)$/i) ? (
        <Box>
          <img
            src={message.attachmentUrl}
            alt={message.fileName}
            onClick={() =>
              setSelectedDocument({
                attachmentUrl: message.attachmentUrl,
                docType: "image",
              })
            }
            style={{
              maxWidth: "200px",
              maxHeight: "200px",
              borderRadius: 8,
              objectFit: "cover",
              display: "block",
              marginBottom: 4,
            }}
          />
          <IconButton
            onClick={() =>
              downloadImage(
                message.attachmentUrl,
                message.fileName || "image.jpg"
              )
            }
            size="small"
            sx={{ mt: 1 }}
          >
            <Download fontSize="small" />
          </IconButton>
        </Box>
      ) : message.fileName?.match(/\.(mp4|webm|mov)$/i) ? (
        <Box>
          <video
            controls
            controlsList="nodownload"
            width="250"
            style={{ borderRadius: 8, marginBottom: 4 }}
            onClick={() =>
              setSelectedDocument({
                attachmentUrl: message.attachmentUrl,
                docType: "video",
              })
            }
          >
            <source src={message.attachmentUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <IconButton
            onClick={() =>
              downloadImage(
                message.attachmentUrl,
                message.fileName || "video.mp4"
              )
            }
            size="small"
          >
            <Download fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <a
          href={message.attachmentUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
            wordBreak: "break-word",
          }}
        >
          {message.fileName || "Download Attachment"}
        </a>
      )}
    </Box>
  );
};

export default AttachmentComponent;
